import styled from 'styled-components';

import { HOME, SPACE } from '../../../../theme/tokens';
import { Text } from '../../../../components';

export const Body = styled.div`
  background: ${HOME.panel};
  border-radius: 16px;
  padding: ${SPACE[12]};
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
`;

export const ChartBox = styled.div<{ $height: number }>`
  position: relative;
  min-height: ${({ $height }) => `${$height}px`};
`;

export const Quiet = styled(Text)`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 14px;
  color: ${HOME.t400};
`;

export const LegendWrap = styled.div`
  display: flex;
  justify-content: flex-end;
`;
